// extracted by mini-css-extract-plugin
export default {"container":"QRButton_container__Qvwso","flex":"QRButton_flex__sl4zs","icon":"QRButton_icon__lOfXU","modal":"QRButton_modal__weDJI"};